import React from "react";

export interface RadioButtonProps
  extends React.DetailedHTMLProps<
    React.InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
  > {
  id: string;
  name: string;
  label?: string;
  error?: boolean;
  wrapperClassName?: string;
}

export const RadioButton = ({
  id,
  label,
  error,
  className,
  wrapperClassName,
  ...rest
}: RadioButtonProps) => {
  return (
    <div
      className={`flex items-center ${
        wrapperClassName ? wrapperClassName : "mr-3"
      }`}
    >
      <input
        {...rest}
        id={id}
        type="radio"
        className={`h-4 w-4 text-blue-600 border-gray-300 focus:ring-blue-500 
          ${error ? "border-red-500 ring-red-500" : ""} ${className}`}
      />
      {label && (
        <label htmlFor={id} className="ml-2 text-sm text-gray-700">
          {label}
        </label>
      )}
    </div>
  );
};

export interface RadioButtonWrapperProps
  extends React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  > {
  label?: string;
  errorText?: string;
  noMargin?: boolean;
  direction?: "vertical" | "horizontal";
}

export const RadioButtonWrapper = ({
  label,
  children,
  errorText,
  className,
  style,
  noMargin,
  direction = "horizontal",
  ...props
}: RadioButtonWrapperProps) => (
  <div
    {...props}
    className={`${noMargin ? "m-0" : "mb-2"} flex flex-col ${className}`}
    style={style}
  >
    {label && <label className="mb-1 text-sm text-gray-600">{label}</label>}
    <div
      className={
        direction === "vertical"
          ? "flex flex-col space-y-2"
          : "flex flex-row space-x-4"
      }
    >
      {children}
    </div>
    {errorText && (
      <small className="mt-1 text-xs text-red-500">{errorText}</small>
    )}
  </div>
);
